import React from "react"
import { Link, useLocation } from "react-router-dom"
import { SecondaryMenu, Submenu } from "@capioweb/ui-components"
import { MenuItem } from "../../../@types/CapioWeb/menu"
import { Z_INDEX } from "../../../constants"
import { LocalesContext } from "../../../context"
import { MenuQueryProps } from "../types"
import { Flex } from "@capioweb/ui-components/src"
import { sendNavigationDataLayerPush } from "../../../utils/piwikPro"

interface MyPagesMenuProps
	extends Pick<MenuQueryProps, "myPagesLogout" | "myPagesAccount"> {
	menu: MenuItem[]
}

const MyPagesMenu: React.FC<MyPagesMenuProps> = ({
	menu,
	myPagesLogout,
	myPagesAccount,
}) => {
	const secondaryMenuLimit = 5

	const { translate, translationKeys } = React.useContext(LocalesContext)
	const location = useLocation()

	return (
		<SecondaryMenu zIndex={Z_INDEX.MyPagesMenu}>
			<SecondaryMenu.List>
				{menu.map((item, i) => (
					<SecondaryMenu.Item
						key={item.id}
						display={
							i > 0
								? {
										_: "none",
										l: i > secondaryMenuLimit - 1 ? "none" : "flex",
								  }
								: "flex"
						}
						className={item.url === location.pathname ? "active" : ""}
					>
						<Link
							to={item?.url ?? "#"}
							onClick={() =>
								sendNavigationDataLayerPush("my_pages_submenu", item.name)
							}
						>
							{item.name}
						</Link>
					</SecondaryMenu.Item>
				))}
			</SecondaryMenu.List>

			<Submenu zIndex={Z_INDEX.MyPagesMenu}>
				<Submenu.Trigger>
					{translate(translationKeys.moreOptions)}
				</Submenu.Trigger>
				<Submenu.Menu>
					<Submenu.List>
						{menu.length > 1 &&
							menu.map((item, i) => (
								<Submenu.Item
									key={i}
									mb={i === menu.length - 1 ? 0 : 3} // Remove margin for last item
									display={
										i === 0
											? "none"
											: {
													_: "block",
													l: i > secondaryMenuLimit - 1 ? "block" : "none",
											  }
									}
									active={item.url === location.pathname}
								>
									<Link
										to={item?.url ?? "#"}
										onClick={() =>
											sendNavigationDataLayerPush("my_pages_submenu", item.name)
										}
									>
										{item.name}
									</Link>
								</Submenu.Item>
							))}

						{menu.length > 1 && menu.length <= secondaryMenuLimit ? (
							<Flex display={{ _: "flex", l: "none" }}>
								<Submenu.Divider />
							</Flex>
						) : (
							<Submenu.Divider />
						)}

						{myPagesAccount && (
							<Submenu.Item mb={3} fontWeight="bold" icon="account-settings">
								<Link to={`${myPagesAccount}`}>
									{translate(translationKeys.manageAccount) ?? "Hantera konto"}
								</Link>
							</Submenu.Item>
						)}
						{myPagesLogout && (
							<Submenu.Item mb={0} fontWeight="bold" icon="logout">
								<Link to={`${myPagesLogout}`}>
									{translate(translationKeys.logout) ?? "Logga ut"}
								</Link>
							</Submenu.Item>
						)}
					</Submenu.List>
				</Submenu.Menu>
			</Submenu>
		</SecondaryMenu>
	)
}

export { MyPagesMenu }
